<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <a class="decoration">Users</a>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        User Tracking Report
      </h6>

      <div class="container-fluid">
        <div style="border: 0; padding: 0; min-height: 0;" class="navbar background_color">
          <div class="d-flex">
            <b-input-group size="sm" style="width: 225px;">
              <b-form-input
                id="filter-input"
                v-model="filter"
                @input="loadMiinventory()"
                type="search"
                placeholder="Search"
              />
            </b-input-group>

            <div style="margin-top: 11px;" class="ms-2">
              <span class="custom-breadcrumb">
                <b>Showing {{ currentPage }}-{{ currentPage * perPage }} of {{ totalRows }} items.</b>
              </span>
            </div>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else class="table-responsive">
              <b-table
                responsive
                style="font-size: small;"
                class="table-hover"
                :items="all_datas"
                :fields="fields"
                :current-page="currentPage"
                head-variant="dark"
                :filter="filter"
                :filter-included-fields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                show-empty
                small
              >
                <template #cell(number)="row">
                  {{ (currentPage - 1) * perPage + row.index + 1 }}
                </template>

                <template #cell(ip)="row">
                  <span v-html="row.item.ip"></span>
                </template>

                <template #cell(action_button)="row">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-primary bdr-rad"
                    @click="openVisit(row.item.id)"
                  >
                    View
                  </button>
                </template>
              </b-table>

              <b-col style="padding-left: 0;" sm="7" md="2" class="my-1 mb-4">
                <b-pagination
                  @change="pageChanged"
                  v-model="currentPage"
                  pills
                  :total-rows="totalRows"
                  :per-page="perPage"
                  size="sm"
                />
              </b-col>
            </div>
          </div>
        </div>
      </div>

      <br><br>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: {
    TopNavbar,
    ContentFooter
  },

  data() {
    return {
      all_datas: [],
      access_token: authService.isLoggedIn(),
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      FromDate: null,
      ToDate: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      previousPage: 1,
      perPage: 15,
      isLoading: true,
      fields: [
        { key: "number", label: "#", sortable: true, sortDirection: "desc" },
        { key: "username", label: "User", sortable: true },
        { key: "ip", label: "IP", sortable: true },
        { key: "visit_time", label: "Visit Time", sortable: true },
        { key: "action", label: "Action", sortable: true },
        { key: "action_button", label: "Action Button" }
      ]
    };
  },

  mounted() {
    this.loadMiinventory();
  },

  methods: {
    async loadMiinventory(page = this.currentPage) {
      this.isLoading = true;

      try {
        const { data } = await axios.get("/user/indexloginvist", {
          params: {
            page,
            perPage: this.perPage,
            filter: this.filter,
            FromDate: this.FromDate,
            ToDate: this.ToDate
          },
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json"
          }
        });

        this.all_datas = data.all_data;
        this.totalRows = data.total_count;
        this.currentPage = data.page;
      } catch (error) {
        console.log(error.response);
      } finally {
        this.isLoading = false;
      }
    },

    openVisit(id) {
      this.$router.push("/user/visitview?id=" + id);
    },

    pageChanged(newPage) {
      if (newPage !== this.previousPage) {
        this.previousPage = newPage;
        this.loadMiinventory(newPage);
      }
    }
  }
};
</script>
